import React from 'react';

const RadiationCleanupDescription = (
  <ul>
    <li>
      <strong>
        The cleanup of an Air Force B-52 bomber carrying nuclear weapons off the
        coast of Palomares, Spain
      </strong>{' '}
      between January 17, 1966 and March 31, 1967
    </li>
    <li>
      <strong>
        The response to the fire onboard an Air Force B-52 bomber carrying
        nuclear weapons near Thule Air Force Base in Greenland
      </strong>{' '}
      between January 21, 1968 and September 25, 1968
    </li>
    <li>
      <strong>The cleanup of Hiroshima and Nagasaki or Enewetak Atoll</strong>{' '}
      between January 1, 1977 and December 31, 1980
    </li>
  </ul>
);

export default RadiationCleanupDescription;
